import { render, staticRenderFns } from "./NewTracing.vue?vue&type=template&id=0e470671&scoped=true"
import script from "./NewTracing.vue?vue&type=script&lang=js"
export * from "./NewTracing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e470671",
  null
  
)

export default component.exports